import { createFileRoute } from "@tanstack/react-router";

import { Centered } from "@/components/ui/container";

export const Route = createFileRoute("/_auth/_app/accessions/new")({
  beforeLoad: async ({ context: { user } }) => {
    if (
      !user.hasRole([
        "blis_org_tech",
        "blis_lab_assistant",
        "blis_lab_tech",
        "blis_lab_manager",
      ])
    ) {
      throw new Error("Unauthorized");
    }
  },
  errorComponent: ({ error }) => <Centered>{error.message}</Centered>,
});
